import { render, staticRenderFns } from "./DashboardAppointments.vue?vue&type=template&id=361dffde&scoped=true&"
import script from "./DashboardAppointments.vue?vue&type=script&lang=ts&"
export * from "./DashboardAppointments.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAppointments.vue?vue&type=style&index=0&id=361dffde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361dffde",
  null
  
)

export default component.exports